import { useTranslation } from "../components/Translation"
import css from "../style.module.scss"
import checkIcon from "../static/icon-check--white.svg"

export function EmailVerificationSuccess({ onClose }: { onClose: () => void }) {
  const t = useTranslation()

  return (
    <div className={css.content}>
      <div className={css["success-icon"]}>
        <img src={checkIcon} alt="Check icon" width={40} height={40} />
      </div>
      <h3 className={css["success-title"]}>{t("email_verified")}</h3>
      <p className={css["success-text"]}>{t("email_verification_success")}</p>
      <button className={css.submit} type="button" onClick={onClose}>
        {t("finish")}
      </button>
    </div>
  )
}
